import { defineStore } from "pinia";
import { computed, reactive } from "vue";

export const useLoadingService = defineStore("loadingService", () => {
  const tasks = reactive(new Map());
  const order = reactive([]); // ← make it reactive

  const isVisible = computed(() => order.length > 0);

  const current = computed(() => {
    const topId = order[order.length - 1];
    return topId ? tasks.get(topId) : undefined;
  });

  const title = computed(() => (current.value && current.value.title) || "");
  const progress = computed(
    () => (current.value && current.value.progress) ?? undefined
  );

  function start(taskId, opts = {}) {
    if (!tasks.has(taskId)) order.push(taskId);
    tasks.set(taskId, { ...opts });
  }

  function update(taskId, opts = {}) {
    if (!tasks.has(taskId)) return;
    const prev = tasks.get(taskId) || {};
    tasks.set(taskId, { ...prev, ...opts });
  }

  function stop(taskId) {
    if (!tasks.has(taskId)) return;
    tasks.delete(taskId);
    const idx = order.indexOf(taskId);
    if (idx >= 0) order.splice(idx, 1);
  }

  function stopAll() {
    tasks.clear();
    order.splice(0, order.length);
  }

  return { isVisible, title, progress, start, update, stop, stopAll };
});
